import { RDGrazing } from '@cibo/core'
import { useFigures } from '@cibo/ui'
import { Typography } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailPanelTable } from '../DetailPanelTable'

export const GrazingPanelTable = () => {
  const { t } = useTranslation('@cibo/landmanager/GrazingPanelTable')
  const { livestockSpecies } = useFigures()
  const columns = useMemo(
    () => [
      {
        header: t('date'),
        cellContents: (grazingEvents?: RDGrazing) => (
          <>
            {grazingEvents?.input?.events.map(({ startDate, endDate }, i) => (
              <Typography key={`${i}${startDate}`} variant="body2">
                {t('dates', { startDate: new Date(startDate), endDate: new Date(endDate) })}
              </Typography>
            ))}
          </>
        ),
      },
      {
        header: t('species'),
        cellContents: (grazingEvents?: RDGrazing) => (
          <>
            {grazingEvents?.input?.events.map(({ startDate, species }, i) => (
              <Typography key={`${i}${startDate}`} variant="body2">
                {species !== undefined ? livestockSpecies(species) : '--'}
              </Typography>
            ))}
          </>
        ),
      },
      {
        header: t('stockingRate'),
        cellContents: (grazingEvents?: RDGrazing) => (
          <>
            {grazingEvents?.input?.events.map(({ startDate, stockingRate }, i) => (
              <Typography key={`${i}${startDate}`} variant="body2">
                {!!stockingRate ? stockingRate : '--'}
              </Typography>
            ))}
          </>
        ),
      },
    ],
    []
  )
  return <DetailPanelTable<RDGrazing> traitId="grazing" columns={columns} />
}
